'use client'

import * as Sentry from '@sentry/nextjs'
import React from 'react'

import '@/shared/styles/globals.scss'
import '@/shared/styles/index.css'

import { ErrInternalServerError } from '@/_pages/error-internal-server-error'
import taongaBeachImage from '@/shared/assets/taongaBeach.jpg'
import { getPublicEnv } from '@/shared/env'
import { I18nProvider } from '@/shared/providers/i18n/provider'
import { fontFaceVariables, fontTokenCss } from '@/shared/styles/fonts'

// NOTE: `global-error` replaces the root layout when active, so the styles, the font variables
// and the I18nProvider that `ErrInternalServerError` relies on have to be set up here again.
// The variables matter because `ErrorWidget` renders a Button whose taonga-ui style asks for the
// `montserrat` token, which is a var() reference that resolves to nothing without them.
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
    React.useEffect(() => {
        Sentry.captureException(error)
    }, [error])

    // NOTE: the root layout renders <PublicEnv />, which never runs when the layout itself fails,
    // hence the fallback language.
    const { NEXT_PUBLIC_LANG: lang = 'en' } = getPublicEnv()

    return (
        <html lang={lang} className={fontFaceVariables(lang)}>
            <head>
                <style>{fontTokenCss(lang)}</style>
            </head>
            <body
                style={{
                    backgroundImage: `url('${taongaBeachImage.src}')`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'fixed',
                    backgroundPosition: 'center',
                }}
            >
                <I18nProvider lang={lang}>
                    <ErrInternalServerError message={error.message} digest={error.digest} />
                </I18nProvider>
            </body>
        </html>
    )
}
